import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import FormSousLot from "./FormSousLot";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import * as mem from "./recopieLotFournisseur";
import * as intchaine from "./interface-chaine";
import OptionsPays from "./OptionsPays";
import ModalCreationFournisseur from "./ModalCreationFournisseur";
import {DEBUG} from "./utilitaires";


export default function FormCreerFournisseur() {
  //on va voir si des valeurs ont été sauvegardées 
  var val;
  val = mem.getChampFournisseur("nomFournisseur");
  const [nomFournisseur, setNomFournisseur] = useState(val);
  val = mem.getChampFournisseur("identFournisseur");
  const [identFournisseur, setIdentFournisseur] = useState(val);
  val = mem.getChampFournisseur("adressePostale");
  const [adressePostale, setAdressePostale] = useState(val);
  val = mem.getChampFournisseur("pays");
  const [pays, setPays] = useState(val);

  val = mem.getChampFournisseur("nomContact");
  const [nomContact, setNomContact] = useState(val);
  val = mem.getChampFournisseur("adresseEmail");
  const [adresseEmail, setAdresseEmail] = useState(val);
  val = mem.getChampFournisseur("numTelephone");
  const [numTelephone, setNumTelephone] = useState(val);

  //les messages d'erreur pour chaque champ
  const [msgErreurNomFournisseur, setMsgErreurNomFournisseur] = useState("");
  const [msgErreurIdentFournisseur, setMsgErreurIdentFournisseur] =
    useState("");
  const [msgErreurAdressePostale, setMsgErreurAdressePostale] = useState("");
  const [msgErreurPays, setMsgErreurPays] = useState("");
  const [msgErreurNomContact, setMsgErreurNomContact] = useState("");
  const [msgErreurAdresseEmail, setMsgErreurAdresseEmail] = useState("");
  const [msgErreurNumTelephone, setMsgErreurNumTelephone] = useState("");

  //pour le modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  //pour modal annuler
  const [showAnnuler, setShowAnnuler] = useState(false);  
  const handleCloseAnnuler = () => setShowAnnuler(false);

  const [creationFournisseur, setCreationFournisseur] = useState(false);

  //on change les champs au moindre input pour affichage et on sauvegarde en même temps
  function changerNomFournisseur(e, value) {
    e.preventDefault();   
    setNomFournisseur(value);
    setMsgErreurNomFournisseur("");
    mem.changerChampFournisseur("nomFournisseur", value);
  }
  function changerIdentFournisseur(e, value) {
    e.preventDefault();
    setIdentFournisseur(value);
    setMsgErreurIdentFournisseur("");
    mem.changerChampFournisseur("identFournisseur", value);
  }
  function changerAdressePostale(e, value) {
    e.preventDefault();
    setAdressePostale(value);
    setMsgErreurAdressePostale("");
    mem.changerChampFournisseur("adressePostale", value);
  }
  function changerPays(e, value) {
    e.preventDefault();
    setPays(value);
    setMsgErreurPays("");
    mem.changerChampFournisseur("pays", value);
  }
  function changerNomContact(e, value) {
    e.preventDefault();
    setNomContact(value);
    setMsgErreurNomContact("");
    mem.changerChampFournisseur("nomContact", value);
  }
  function changerAdresseEmail(e, value) {
    e.preventDefault();
    setAdresseEmail(value);
    setMsgErreurAdresseEmail("");
    mem.changerChampFournisseur("adresseEmail", value);
  }
  function changerNumTelephone(e, value) {
    e.preventDefault();
    setNumTelephone(value);
    setMsgErreurNumTelephone("");
    mem.changerChampFournisseur("numTelephone", value);
  }

  //pour vérifier que l'utilistateur veut vraiment tout annuler
  function proposerAnnulerFournisseur(e) {
    e.preventDefault();
    setShowAnnuler(true)
  }

  //si l'utilisateur confirme qu'il veut tout effacer, on efface (y compris la sauvegarde)
  function annulerFournisseur(e) {
    e.preventDefault();
    setShowAnnuler(false)

    setNomFournisseur("");
    setMsgErreurNomFournisseur("");
    mem.changerChampFournisseur("nomFournisseur", "");
    setIdentFournisseur("");
    setMsgErreurIdentFournisseur("");
    mem.changerChampFournisseur("identFournisseur", "");
    setAdressePostale("");
    setMsgErreurAdressePostale("");
    mem.changerChampFournisseur("adressePostale", "");
    setPays("");
    mem.changerChampFournisseur("pays", "");
    setNomContact("");
    setMsgErreurNomContact("");
    mem.changerChampFournisseur("nomContact", "");
    setAdresseEmail("");
    setMsgErreurAdresseEmail("");
    mem.changerChampFournisseur("adresseEmail", "");
    setNumTelephone("");
    setMsgErreurNumTelephone("");
    mem.changerChampFournisseur("numTelephone", "");
  }

  //les fonctions de validation et les messages d'erreur associés
  function validerNomFournisseur() {
    if (nomFournisseur.length > 0) {
      return true;
    }
    setMsgErreurNomFournisseur("--erreur sur le nom fournisseur--");
    return false;
  }

  function validerIdentFournisseur() {
    if (identFournisseur.length > 0) {
      return true;
    }
    setMsgErreurIdentFournisseur("--erreur sur l'identité fournisseur--");
    return false;
  }

  function validerAdressePostale() {
    if (adressePostale.length > 0) {
      return true;
    }
    setMsgErreurAdressePostale("--erreur sur l'adresse postale--");
    return false;
  }

  function validerPays() {
    if (pays.length > 0) {
      return true;
    }
    setMsgErreurPays("--erreur sur le pays--");
    return false;
  }


  function validerNomContact() {
    if (nomContact.length > 0) {
      return true;
    }
    setMsgErreurNomContact("--erreur sur le nom contact--");
    return false;
  }

  // verification par expression regulière
  function validerAdresseEmail() {
    // if (adresseEmail.length > 0) {
    if (/^[a-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,6}$/i.test(adresseEmail)) {
      return true;
    }
    setMsgErreurAdresseEmail("--erreur sur l'adresse email--");
    return false;
  }

  function validerNumTelephone() {
    if (numTelephone.length > 0) {
      return true;
    }
    setMsgErreurNumTelephone("--erreur sur le numéro de téléphone--");
    return false;
  }

  //création du Fournisseur en faisant des vérifications auparavant
  async function goCreerFournisseur(e) {
    e.preventDefault();
    if (!intchaine.accountFournisseur) {
      setMsgModal("Chosissez (ou créez) d'abord un compte Metamask");
      setShow(true);
      return
    } 
    let identF = await intchaine.getIdFournisseurParAdresse(intchaine.accountFournisseur)
    if (identF > 0) {
      setMsgModal("Un fournisseur existe déjà sur la blockchain avec ce compte, changez de compte ou créez un compte avec Metamask");
      setShow(true);
      return      
    }
    //on fait les vérifications
    let correct = true;
    if (!validerNomFournisseur()) {
      correct = false;
    }
    if (!validerIdentFournisseur()) {
      correct = false;
    }
    if (!validerAdressePostale()) {
      correct = false;
    }
    if (!validerPays()) {
      correct = false;
    }    
    if (!validerNomContact()) {
      correct = false;
    }
    if (!validerAdresseEmail()) {
      correct = false;
    }
    if (!validerNumTelephone()) {
      correct = false;
    }
    if (!correct) { 
      setMsgModal("Fournisseur non valide, vérifiez les champs incorrects");
      setShow(true);
    } else {
      if (DEBUG) console.log("Creation du Fournisseur");
      try {  // try catch plus vraiment nécessaire puisqu'on passe au modal
        setCreationFournisseur(true)
      } catch(e) {
        setMsgModal("Erreur dans la création du fournisseur sur la blockchain");
        setShow(true);
      }
    
    }
  }

  return (
    <>
      <Button
        size="sm"
        variant="outline-primary"
        onClick={(e) => proposerAnnulerFournisseur(e)}
      >
        Tout effacer
      </Button>
      <br />
      <br />
      <h4 style={{ backgroundColor: "lightblue" }}  className="ps-2"  >Nouveau fournisseur</h4>
      {/* <Form style={{ backgroundColor: "#d4d6d9" }}> */}
      <Form>  
        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2" >Nom Fournisseur</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez le nom du Fournisseur"
            value={nomFournisseur}
            maxLength={1000}
            onChange={(e) => changerNomFournisseur(e, e.target.value)}
          />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurNomFournisseur && msgErreurNomFournisseur}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Identification Fournisseur</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez l'identification du Fournisseur"
            value={identFournisseur}
            maxLength={1000}
            onChange={(e) => changerIdentFournisseur(e, e.target.value)}
          />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurIdentFournisseur && msgErreurIdentFournisseur}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Adresse Postale</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="entrez l'adresse postale du Fournisseur"
            value={adressePostale}
            maxLength={1000}
            onChange={(e) => changerAdressePostale(e, e.target.value)}
          />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurAdressePostale && msgErreurAdressePostale}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Pays</Form.Label>
          <Form.Select
            value={pays}
            onChange={(e) => changerPays(e, e.target.value)}
          >
            <OptionsPays />
          </Form.Select>
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurPays && msgErreurPays}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Nom du Contact</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez le nom du contact"
            value={nomContact}
            maxLength={1000}
            onChange={(e) => changerNomContact(e, e.target.value)}
          />
          <Form.Text className="text-muted">
            cette information ne sera pas inscrite dans la blockchain
          </Form.Text>
          <br />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurNomContact && msgErreurNomContact}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Adresse Email</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez l'adresse email du contact"
            value={adresseEmail}
            maxLength={1000}
            onChange={(e) => changerAdresseEmail(e, e.target.value)}
          />
          <Form.Text className="text-muted">
            cette information ne sera pas inscrite dans la blockchain
          </Form.Text>
          <br />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurAdresseEmail && msgErreurAdresseEmail}
          </span>
        </Form.Group>

        <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
          <Form.Label className="ps-2">Numéro de Téléphone</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            placeholder="entrez le numéro de téléphone du contact"
            value={numTelephone}
            maxLength={1000}
            onChange={(e) => changerNumTelephone(e, e.target.value)}
          />
          <Form.Text className="text-muted">
            cette information ne sera pas inscrite dans la blockchain
          </Form.Text>
          <br />
          <span style={{ color: "red", fontStyle: "italic" }}>
            {msgErreurNumTelephone && msgErreurNumTelephone}
          </span>
        </Form.Group>
      </Form>
      <br />
      <Button variant="primary" onClick={(e) => goCreerFournisseur(e)}>
        Creer Fournisseur
      </Button>{" "}
      <Button variant="secondary" onClick={(e) => proposerAnnulerFournisseur(e)}>
        Tout effacer
      </Button>
      <br />
      <br />




      {/* modal pour message d'erreur */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Création Fournisseur</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      {/* modal pour confirmer tout affacer */}
      <Modal show={showAnnuler} onHide={handleCloseAnnuler}>
        <Modal.Header closeButton>
          <Modal.Title>Création Fournisseur</Modal.Title>
        </Modal.Header>
        <Modal.Body>Etes-vous sûr de vouloir tout effacer?</Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseAnnuler}>
            Non
          </Button>          
          <Button variant="secondary" onClick= {(e) => annulerFournisseur(e)}>
            Oui, tout effacer
          </Button>
        </Modal.Footer>
      </Modal>


      {/* grand modal pour vérifier les données puis créer fournisseur. On passe en paramètre reset une fonction! */}
      {creationFournisseur && <ModalCreationFournisseur montrer={true} reset={setCreationFournisseur}/>}
    </>
  );
}
